"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n\n  .retailers-limit {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background-color: #f0f0f0;\n\n    p {\n      font-family: ", ";\n      font-size: 12px;\n      line-height: 26px;\n      color: #262626;\n      text-align: center;\n    }\n  }\n\n  > * + * {\n    margin-left: -5px;\n  }\n"])), _variables.FontFamily.Lato);

exports.Container = Container;